// Role-based access control for OMNIA OS modules.
// Leadership (admin/ceo/director) see everything ("*"); other roles are scoped.
// "hub" and "assistant" are available to every role.

export const ROLE_ACCESS = {
  admin: "*",
  ceo: "*",
  director: "*",
  ventas: ["hub", "crm", "flow", "intelligence", "assistant", "tagma"],
  marketing: ["hub", "aura", "crm", "intelligence", "shop-orders", "assistant", "tagma"],
  disenador: ["hub", "gout", "flow", "assistant"],
  interior_designer: ["hub", "gout", "flow", "assistant"],
  arquitecto: ["hub", "gout", "flow", "assistant"],
  compras: ["hub", "vetta", "finance", "assistant"],
  fabricante: ["hub", "vetta", "flow", "shop-orders", "assistant"],
  proveedor: ["hub", "vetta", "assistant"],
  operaciones: ["hub", "vetta", "flow", "automation", "shop-orders", "assistant"],
  retailer: ["hub", "aura", "shop-orders", "assistant"],
  cuentas: ["hub", "finance", "crm", "shop-orders", "intelligence", "assistant"],
  produccion: ["hub", "vetta", "flow", "shop-orders", "assistant"],
  contador: ["hub", "contabilidad", "assistant"],
  cliente: ["hub", "gout", "assistant"],
  usuario_rd: ["hub", "cuadrillas", "flotilla", "planning", "sheets", "omnia", "assistant"],
};

// Rutas permitidas para el rol restringido usuario_rd (empresa RD)
export const RD_ALLOWED_PATHS = ["/os", "/os/omnia", "/os/cuadrillas", "/os/control-tickets", "/os/flotilla", "/os/planning", "/os/sheets"];

export function isPathAllowedForRD(pathname) {
  if (pathname === "/os") return true;
  return RD_ALLOWED_PATHS.slice(1).some((p) => pathname === p || pathname.startsWith(p + "/"));
}

export function canAccess(role, moduleKey) {
  if (role === "usuario_rd") return ROLE_ACCESS.usuario_rd.includes(moduleKey);
  // Todos los usuarios ven TODOS los módulos; los datos se filtran por usuario.
  // Excepciones: panel Admin (solo admin), Contabilidad (admin/ceo/director/contador),
  // y Métricas Maestras (solo admin/ceo/director — datos agregados de todos los usuarios).
  if (moduleKey === "admin") return role === "admin";
  if (moduleKey === "bitacora") return role === "admin";
  if (moduleKey === "design") return role === "admin";
  if (moduleKey === "workflows") return role === "admin";
  if (moduleKey === "copiloto") return ["admin", "ceo", "director"].includes(role);
  if (moduleKey === "administracion") return role === "admin";
  if (moduleKey === "marketplace") return ["admin", "ceo", "director"].includes(role);
  if (moduleKey === "extensiones") return role === "admin";
  if (moduleKey === "integraciones") return role === "admin";
  if (moduleKey === "plataforma") return role === "admin";
  if (moduleKey === "contabilidad") return ["admin", "ceo", "director", "contador"].includes(role);
  if (moduleKey === "master-metrics") return ["admin", "ceo", "director"].includes(role);
  return true;
}
